import settings from '@/settings'

const multipleMethods = (headers, payload) => {
  console.log(payload)
  let url = `${settings.apetrusApi}/requisicoes/${payload.id ? `${payload.id}/` : ''}`

  const data = {
    method: payload.method || 'GET',
    mode: 'cors',
    headers: headers
  }
  if (payload.params) {
    const keys = Object.keys(payload.params)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${payload.params[keys[i]]}`
    }
  }
  if (payload.method === 'GET') {
    data.cache = 'default'
  } else data.body = JSON.stringify(payload.body)

  return fetch(url, data)
}

export default {
  multipleMethods
}
